import { render, staticRenderFns } from "./PortalResultadosApoiado.vue?vue&type=template&id=13b6b7b1&"
import script from "./PortalResultadosApoiado.vue?vue&type=script&lang=js&"
export * from "./PortalResultadosApoiado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports